/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundDto } from '../../models/backend-own-fund-dto';

export interface FinancingSourcesOwnFundsList$Params {
  /**
   * * `0` - По годам
   * * `1` - По кварталам
   * * `2` - По месяцам
   * * `3` - По полугодиям
   */
  accrual_frequency?: 0 | 1 | 2 | 3;
  create_date?: string;
  is_blocked?: boolean;
  name?: string;
  ownership_share?: number;
  payment_due_days?: number;
  profit_share_percentage?: number;
  should_pay_dividends?: boolean;
  source_date?: string;
  source_investor?: string;
  source_sum?: number;
  variant?: number;
}

export function financingSourcesOwnFundsList(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesOwnFundsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOwnFundDto>>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsList.PATH, 'get');
  if (params) {
    rb.query('accrual_frequency', params.accrual_frequency, {});
    rb.query('create_date', params.create_date, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('name', params.name, {});
    rb.query('ownership_share', params.ownership_share, {});
    rb.query('payment_due_days', params.payment_due_days, {});
    rb.query('profit_share_percentage', params.profit_share_percentage, {});
    rb.query('should_pay_dividends', params.should_pay_dividends, {});
    rb.query('source_date', params.source_date, {});
    rb.query('source_investor', params.source_investor, {});
    rb.query('source_sum', params.source_sum, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOwnFundDto>>;
    }),
  );
}

financingSourcesOwnFundsList.PATH = '/api/financing_sources/own_funds/';
